export default __webpack_public_path__ + "static/media/joinus.546ac519.jpg";